"use client"

import { useFrontendPreferences } from "@lib/frontend-preferences"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { Button, Heading, Text } from "@modules/common/components/ui"

const SignInPrompt = () => {
  const { t } = useFrontendPreferences()

  return (
    <div className="bg-white flex items-center justify-between">
      <div>
        <Heading level="h2" className="txt-xlarge">
          {t.cart.signInTitle}
        </Heading>
        <Text className="txt-medium text-ui-fg-subtle mt-2">
          {t.cart.signInBody}
        </Text>
      </div>
      <div>
        <LocalizedClientLink href="/account">
          <Button
            variant="secondary"
            className="h-10"
            data-testid="sign-in-button"
          >
            {t.cart.signIn}
          </Button>
        </LocalizedClientLink>
      </div>
    </div>
  )
}

export default SignInPrompt
